/**
 * Attaches a given access token to a MS Graph API call. Returns information about the user
 * @param accessToken
 */

const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me?$select=displayName",
  graphSitesEndpoint:
    "https://graph.microsoft.com/v1.0/sites/221edcbe-1484-4331-9fdc-1e64e2e7d805/lists/5b5aa758-c7bc-4228-a89d-c494a668a075/items?$expand=fields($select=Title,webUrl,isActive)",
};

export async function callMsGraphMe(accessToken) {
  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append("Authorization", bearer);

  const options = {
    method: "GET",
    headers: headers,
  };

  return fetch(graphConfig.graphMeEndpoint, options)
    .then((response) => response.json())
    .catch((error) => console.log(error));
}

export async function callMsGraphSites(accessToken) {
  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append("Authorization", bearer);

  const options = {
    method: "GET",
    headers: headers,
  };

  return fetch(graphConfig.graphSitesEndpoint, options)
    .then((response) => response.json())
    .catch((error) => console.log(error));
}

export async function callMsGraphSiteId(accessToken, siteDisplayName) {
  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append("Authorization", bearer);

  const options = {
    method: "GET",
    headers: headers,
  };

  return fetch(
    `https://graph.microsoft.com/v1.0/sites/maxigroup.sharepoint.com:/sites/${siteDisplayName}?$select=id`,
    options
  )
    .then((response) => response.json())
    .catch((error) => console.log(error));
}

export async function callMsGraphImageUUID(accessToken, UUID) {
  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append("Authorization", bearer);

  const options = {
    method: "GET",
    headers: headers,
  };

  try {
    const response = await fetch(
      `https://graph.microsoft.com/v1.0/sites/221edcbe-1484-4331-9fdc-1e64e2e7d805/lists/cf0154b6-9c0d-4689-b93d-b5de64e26794/items/${UUID}`,
      options
    );
    return response.status;
  } catch (error) {
    console.log(error);
    throw error; // Re-throw the error to handle it in the calling function if needed
  }
}

export async function callMsGraphSiteDriveId(accessToken, siteId) {
  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append("Authorization", bearer);

  const options = {
    method: "GET",
    headers: headers,
  };

  return fetch(
    `https://graph.microsoft.com/v1.0/sites/${siteId}/drives?$select=id`,
    options
  )
    .then((response) => response.json())
    .catch((error) => console.log(error));
}

export async function callBackend(body) {
  const options = {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    method: "POST",
    body: JSON.stringify(body),
  };

  let url

  if(location.hostname === "localhost") {
     url = "http://127.0.0.1:3000/SMSIR";
  } else {
    url = "https://maxipdfserver-eyh8g4a4cdghfma6.ukwest-01.azurewebsites.net/SMSIR";
  }

  console.log(url)

  return fetch(url, options)
    .then((res) => res.json())
    .then((res) => console.log(res));
}

export async function callGraphCreateListItem(body) {
  const headers = new Headers();
  const bearer = `Bearer ${body.accessToken}`;

  headers.append("Authorization", bearer);
  headers.append("Content-Type", "application/json");

  const requestBody = {
    fields: {
      Project: body.formData.project,
      Construction_x0020_Phase_x0020_P: body.formData.questions[0].action,
      Construction_x0020_Phase_x0020_P0: body.formData.questions[0].comment,
      Scaffolding_x0020_Action: body.formData.questions[1].action,
      Scaffolding_x0020_Comment: body.formData.questions[1].comment,
      Pollution_x0020__x0026__x0020_Wa: body.formData.questions[2].action,
      Pollution_x0020__x0026__x0020_Wa0: body.formData.questions[2].comment,
      Mobile_x0020_Towers_x0020_Action: body.formData.questions[3].action,
      Mobile_x0020_Towers_x0020_Commen: body.formData.questions[3].comment,
      Fire_x0020_Plan_x0020_Action: body.formData.questions[4].action,
      Fire_x0020_Plan_x0020_Comment: body.formData.questions[4].comment,
      Trestles_x0020__x0026__x0020_Lad: body.formData.questions[5].action,
      Trestles_x0020__x0026__x0020_Lad0: body.formData.questions[5].comment,
      Risk_x0020_Assessments_x0020__x0: body.formData.questions[6].action,
      Risk_x0020_Assessments_x0020__x00: body.formData.questions[6].comment,
      Powered_x0020_Access_x0020_Equip: body.formData.questions[7].action,
      Powered_x0020_Access_x0020_Equip0: body.formData.questions[7].comment,
      Inspection_x0020_Reports_x0020_A: body.formData.questions[8].action,
      Inspection_x0020_Reports_x0020_C: body.formData.questions[8].comment,
      Roof_x0020_Work_x0020__x002f__x0: body.formData.questions[9].action,
      Roof_x0020_Work_x0020__x002f__x00: body.formData.questions[9].comment,
      Statutory_x0020_Notices_x0020_Di: body.formData.questions[10].action,
      Statutory_x0020_Notices_x0020_Di0: body.formData.questions[10].comment,
      Steel_x0020_Erection_x0020_Actio: body.formData.questions[11].action,
      Steel_x0020_Erection_x0020_Comme: body.formData.questions[11].comment,
      Accommodation_x0020_Action: body.formData.questions[12].action,
      Accommodation_x0020_Comment: body.formData.questions[12].comment,
      Excavations_x0020_Action: body.formData.questions[13].action,
      Excavations_x0020_Comment: body.formData.questions[13].comment,
      Mess_x0020__x002f__x0020_Drying_: body.formData.questions[14].action,
      Mess_x0020__x002f__x0020_Drying_0: body.formData.questions[14].comment,
      Excavators_x0020__x0026__x0020_C: body.formData.questions[15].action,
      Excavators_x0020__x0026__x0020_C0: body.formData.questions[15].comment,
      Drinking_x0020_Water_x0020_Actio: body.formData.questions[16].action,
      Drinking_x0020_Water_x0020_Comme: body.formData.questions[16].comment,
      Fork_x0020_Lift_x0020_Truck_x002: body.formData.questions[17].action,
      Fork_x0020_Lift_x0020_Truck_x0020: body.formData.questions[17].comment,
      Hot_x0020__x002f__x0020_Cold_x00: body.formData.questions[18].action,
      Hot_x0020__x002f__x0020_Cold_x000: body.formData.questions[18].comment,
      Other_x0020_Plant_x0020__x0026__: body.formData.questions[19].action,
      Other_x0020_Plant_x0020__x0026__0: body.formData.questions[19].comment,
      Soap_x0020__x0026__x0020_Hand_x0: body.formData.questions[20].action,
      Soap_x0020__x0026__x0020_Hand_x00: body.formData.questions[20].comment,
      COSHH_x003b__x0020_Noise_x0020__: body.formData.questions[21].action,
      COSHH_x003b__x0020_Noise_x0020__0: body.formData.questions[21].comment,
      Toilet_x0020_Facilities_x0020_Ac: body.formData.questions[22].action,
      Toilet_x0020_Facilities_x0020_Co: body.formData.questions[22].comment,
      Confined_x0020_Space_x0020_Actio: body.formData.questions[23].action,
      Confined_x0020_Space_x0020_Comme: body.formData.questions[23].comment,
      First_x0020_Aid_x0020_Box_x0020_: body.formData.questions[24].action,
      First_x0020_Aid_x0020_Box_x0020_0: body.formData.questions[24].comment,
      Demolition_x0020_Action: body.formData.questions[25].action,
      Demolition_x0020_Comment: body.formData.questions[25].comment,
      Accident_x0020_Book_x0020__x0026: body.formData.questions[26].action,
      Accident_x0020_Book_x0020__x00260: body.formData.questions[26].comment,
      O_x002f_H_x0020__x0026__x0020_U_: body.formData.questions[27].action,
      O_x002f_H_x0020__x0026__x0020_U_0: body.formData.questions[27].comment,
      First_x0020_Aid_x0020_Coordinato: body.formData.questions[28].action,
      First_x0020_Aid_x0020_Coordinato0: body.formData.questions[28].comment,
      Permit_x0020_To_x0020_Work_x0020: body.formData.questions[29].action,
      Permit_x0020_To_x0020_Work_x00200: body.formData.questions[29].comment,
      Fire_x0020_Extinguishers_x0020_A: body.formData.questions[30].action,
      Fire_x0020_Extinguishers_x0020_C: body.formData.questions[30].comment,
      Manual_x0020_Handling_x0020_Acti: body.formData.questions[31].action,
      Manual_x0020_Handling_x0020_Comm: body.formData.questions[31].comment,
      Fire_x0020_Escapes_x0020_Action: body.formData.questions[32].action,
      Fire_x0020_Escapes_x0020_Comment: body.formData.questions[32].comment,
      Signage_x0020__x002f__x0020_Illu: body.formData.questions[33].action,
      Signage_x0020__x002f__x0020_Illu0: body.formData.questions[33].comment,
      Fire_x0020_Plan_x0020__x002f__x0: body.formData.questions[34].action,
      Fire_x0020_Plan_x0020__x002f__x00: body.formData.questions[34].comment,
      Housekeeping_x0020_Action: body.formData.questions[35].action,
      Housekeeping_x0020_Comment: body.formData.questions[35].comment,
      General_x0020_Site_x0020_Access_: body.formData.questions[36].action,
      General_x0020_Site_x0020_Access_0: body.formData.questions[36].comment,
      Induction_x0020_Training_x0020_A: body.formData.questions[37].action,
      Induction_x0020_Training_x0020_C: body.formData.questions[37].comment,
      Perimeter_x0020_Fencing_x0020_Ac: body.formData.questions[38].action,
      Perimeter_x0020_Fencing_x0020_Co: body.formData.questions[38].comment,
      Tool_x0020_Box_x0020_Talks_x0020: body.formData.questions[39].action,
      Tool_x0020_Box_x0020_Talks_x00200: body.formData.questions[39].comment,
      Protection_x0020_To_x0020_The_x0: body.formData.questions[40].action,
      Protection_x0020_To_x0020_The_x00: body.formData.questions[40].comment,
      Quality_x0020_Monitoring_x0020_A: body.formData.questions[41].action,
      Quality_x0020_Monitoring_x0020_C: body.formData.questions[41].comment,
      images: sessionStorage.getItem("imgFolder"),
    },
  };

  const options = {
    method: "POST",
    headers: headers,
    body: JSON.stringify(requestBody),
  };
  console.log(options.body);
  return fetch(
    `https://graph.microsoft.com/v1.0/sites/221edcbe-1484-4331-9fdc-1e64e2e7d805/lists/e72c6eec-d969-444f-8ca1-8cf6b8b1a7f1/items`,
    options
  )
    .then((response) => console.log(response.json()))
    .catch((error) => console.log(error));
}

export async function createImageFolder(accessToken, uuid) {
  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append("Authorization", bearer);
  headers.append("Content-Type", "application/json");

  let body = {
    name: uuid,
    folder: {},
    "@microsoft.graph.conflictBehavior": "Fail",
  };

  const options = {
    method: "POST",
    headers: headers,
    body: JSON.stringify(body),
  };

  try {
    fetch(
      "https://graph.microsoft.com/v1.0/drives/b!vtweIoQUMUOf3B5k4ufYBeQSNTLjsaxLrIFosqQdExy2VAHPDZyJRrk9td5k4meU/root/children",
      options
    );
  } catch (error) {
    console.log(error);
    throw error; // Re-throw the error to handle it in the calling function if needed
  }
}

export async function uploadImage(accessToken, uuid, blob, fileName) {
  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;
  headers.append("Authorization", bearer);
  headers.append("Content-Type", "image/png");

  const options = {
    method: "PUT",
    headers: headers,
    body: blob,
  };

  async function getFolderId(accessToken, uuid) {
    const headers = new Headers();
    const bearer = `Bearer ${accessToken}`;
    headers.append("Authorization", bearer);

    const options = {
      method: "GET",
      headers: headers,
    };

    const folderUrl = `https://graph.microsoft.com/v1.0/sites/221edcbe-1484-4331-9fdc-1e64e2e7d805/drives/b!vtweIoQUMUOf3B5k4ufYBeQSNTLjsaxLrIFosqQdExy2VAHPDZyJRrk9td5k4meU/root/children/${uuid}?$select=id,webUrl`;

    let response = await fetch(folderUrl, options);
    response = response.json();

    sessionStorage.setItem("imgFolder", response.webUrl);
    return response;
  }

  const parentItemId = await getFolderId(accessToken, uuid);

  sessionStorage.setItem("imgFolder", parentItemId.webUrl);
  const uploadUrl = `https://graph.microsoft.com/v1.0/sites/221edcbe-1484-4331-9fdc-1e64e2e7d805/drives/b!vtweIoQUMUOf3B5k4ufYBeQSNTLjsaxLrIFosqQdExy2VAHPDZyJRrk9td5k4meU/items/${parentItemId.id}:/${fileName}:/content`;

  const uploadedFile = await fetch(uploadUrl, options);
  return uploadedFile.json();
}

export async function getGroups(accessToken) {
  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;
  headers.append("Authorization", bearer);

  const options = {
    method: "GET",
    headers: headers,
  };

  const groupsUrl = "https://graph.microsoft.com/v1.0/me/memberOf?$Select=id";

  let response = await fetch(groupsUrl, options);
  response = response.json();

  return response;
}
